import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import MapToolbox from 'js/components/map/MapToolbox';

const CreateTerritoryMapToolBox = forwardRef((props, ref) => {
    const clearPath = () => {
        props.setDrawing('');
        props.setPolygonPath([]);
        props.setGooglePolygon(null);
        props.mapCommands.clearRecord();
        if (props?.savedTerritory?.territory?.polygon?.length) {
            props.setEditPolygonDeleted(true);
        }
    };

    const isEditMode = !!props?.savedTerritory?.territoryId;

    return (
        <MapToolbox
            options={{
                handleLayers: false,
                tools: {
                    polygon: {
                        disabled: !!props.polygonPath?.length,
                        allowDelete: false,
                    },
                    polyline: { enabled: false },
                    circle: { enabled: false },
                    rectangle: { enabled: false },
                    addOrRemove: { enabled: false },
                    undo: {
                        disabled: (!props.editPolygonDeleted
                                && isEditMode
                                && props.mapCommands.undoList.length === 1)
                            || !props.mapCommands.hasUndo,
                    },
                    redo: {
                        disabled: !props.mapCommands?.hasRedo,
                    },
                    delete: {
                        disabled: !props.polygonPath?.length,
                    },
                }
            }}
            events={{
                onOverlayComplete: props.onOverlayComplete,
                undo: {
                    onSelect: () => props.mapCommands?.undo()
                },
                redo: {
                    onSelect: () => props.mapCommands?.redo()
                },
                delete: {
                    onSelect: clearPath,
                },
            }}
            margins={{
                top: 24,
                left: 24,
            }}
            onError={props.onError}
        />
    );
});

CreateTerritoryMapToolBox.propTypes = {
    drawingMode: PropTypes.string,
    setDrawingMode: PropTypes.func,
    setPolygonPath: PropTypes.func,
    setGooglePolygon: PropTypes.func,
    setDrawing: PropTypes.func,
    drawing: PropTypes.object,
    mapInstance: PropTypes.object,
    setMarker: PropTypes.func,
    openSnackBar: PropTypes.func,
    mapCommands: PropTypes.shape({
        clearRecord: PropTypes.func,
        hasUndo: PropTypes.bool,
        undo: PropTypes.func,
        hasRedo: PropTypes.bool,
        redo: PropTypes.func,
    }),
};

export default CreateTerritoryMapToolBox;
